import cx from "classnames";

import TextEllipsis from "ds/components/TextEllipsis";
import Typography, { TypographyProps } from "ds/components/Typography";

import styles from "./styles.module.css";

type CardTitleProps = TypographyProps;

const CardTitle = ({ variant, className, children, ...props }: CardTitleProps) => {
  const isString = typeof children === "string";

  if (isString) {
    return (
      <TextEllipsis tooltip={children} tooltipWidthMode="maxWidthSm">
        {(ellipsisProps) => (
          <Typography
            variant={variant}
            {...props}
            {...ellipsisProps}
            className={cx(ellipsisProps.className, styles.title, className)}
          >
            {children}
          </Typography>
        )}
      </TextEllipsis>
    );
  }

  return (
    <Typography variant={variant} {...props} className={cx(styles.title, className)}>
      {children}
    </Typography>
  );
};

CardTitle.displayName = "DS.Card.Title";

export default CardTitle;
